/**
 * IGNIERE §124 補（2026-07-19 user 指摘）：スクロール不能な shelf でも
 * hover で next 矢印が表示される問題の修正。
 *
 * 現象：Horizon slideshow-component は slide.scrollWidth === slide.clientWidth
 * （スクロール余地なし）の状態でも next 矢印を disabled にしないため、hover CSS の
 * opacity:1 が発火し「押せそうな chevron」がユーザーに見える。TOP journal 3 枚・
 * PDP journal 3 枚などで実測。
 *
 * 対策：slideshow-slides の scrollWidth と clientWidth を比較し、
 * scroll 余地が 4px 以下なら slideshow-arrows 全体を display:none に。
 * リサイズやスライド追加時にも再判定する（ResizeObserver で監視）。
 * 冪等：現在値と比較して差分がある時だけ書く。
 */
(function () {
  'use strict';
  const IG = window.IGNIERE_RUNTIME;
  if (!IG || !IG.register) return;

  const observers = new WeakMap();

  function updateShelf(carousel) {
    if (!carousel) return;
    const slides = carousel.querySelector('slideshow-slides');
    const arrows = carousel.querySelector('slideshow-arrows');
    if (!slides || !arrows) return;
    const canScroll = slides.scrollWidth - slides.clientWidth > 4;
    const desired = canScroll ? '' : 'none';
    if (arrows.style.display !== desired) {
      arrows.style.display = desired;
    }
  }

  IG.register('124-scroll-check', {
    apply(root) {
      if (!document.body) return;
      const carousels = document.querySelectorAll(
        'slideshow-component.resource-list__carousel'
      );
      carousels.forEach((carousel) => {
        const slides = carousel.querySelector('slideshow-slides');
        if (!slides) return;
        updateShelf(carousel);
        // ResizeObserver で slides の幅変化を監視（1 度だけ設置）
        if (!observers.has(carousel)) {
          const ro = new ResizeObserver(() => updateShelf(carousel));
          ro.observe(slides);
          observers.set(carousel, ro);
        }
      });
    },
  });
})();
